/*
 * Optional order note for the cart (drawer + page), styled after the active
 * theme's "Add Optional Note" control: a small button that reveals a textarea.
 * The note is Shopify's cart-level `note` attribute, saved via /cart/update.js
 * ({ note }) on input (debounced) and on blur, so it persists server-side and
 * carries through to checkout regardless of which cart form is submitted.
 */
class CartNote extends HTMLElement {
  connectedCallback() {
    this.updateUrl = this.dataset.cartUpdateUrl;
    this.toggle = this.querySelector('[data-note-toggle]');
    this.field = this.querySelector('[data-note-field]');
    this.input = this.querySelector('[data-note-input]');
    this.label = this.querySelector('[data-note-label]');

    if (this.toggle) this.toggle.addEventListener('click', () => this.toggleField());
    if (this.input) {
      this.input.addEventListener('input', () => this.scheduleSave());
      this.input.addEventListener('blur', () => this.save());
    }
  }

  toggleField() {
    if (!this.field) return;
    const isHidden = this.field.hasAttribute('hidden');
    if (isHidden) {
      this.field.removeAttribute('hidden');
      this.toggle.setAttribute('aria-expanded', 'true');
      if (this.input) this.input.focus();
    } else {
      this.field.setAttribute('hidden', '');
      this.toggle.setAttribute('aria-expanded', 'false');
    }
  }

  scheduleSave() {
    window.clearTimeout(this._saveTimer);
    this._saveTimer = window.setTimeout(() => this.save(), 600);
  }

  save() {
    if (!this.input) return;
    const note = this.input.value;
    fetch(this.updateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: note })
    })
      .then(response => response.json())
      .then(() => {
        if (this.label) {
          this.label.textContent = note.trim() ? 'Edit note' : 'Add Optional Note';
        }
      })
      .catch(error => console.error('Cart note save failed', error));
  }
}

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', CartNote);
}
